__turbopack_context__.v({
  "bookAppointmentCta": "DealerInformationSection-module__54mebq__bookAppointmentCta",
  "capitalizeLabel": "DealerInformationSection-module__54mebq__capitalizeLabel",
  "dealerInfoCard": "DealerInformationSection-module__54mebq__dealerInfoCard",
  "dealershipPlpLink": "DealerInformationSection-module__54mebq__dealershipPlpLink",
  "detailsList": "DealerInformationSection-module__54mebq__detailsList",
  "logoSection": "DealerInformationSection-module__54mebq__logoSection",
});
